module.exports = __webpack_public_path__ + "4ba2c3b37514bf3efd8cc51946270be8.svg";